import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// REDUX ACTION
import {
  saveIdentityDocumentsAXN,
  biometricAuthenticationAXN,
  bioTriggerBooleansAXN,
} from '../../actions/biometrics/biometricActions';
import { loadingToggleAXN } from '../../actions/loading/loadingAction';
import { setAlertAXN } from '../../actions/alert/alertActions';

// CAMERA
import Camera from './camera/Camera';

// BUTTON
import Button from '../../components/btn/Button';

// UTILITIES
import { transUTL } from '../../utils/transUTL';
import isEmptyVAL from '../../validations/checks/isEmptyVAL';
import dataURItoBlobUTL from '../../utils/dataURItoBlobUTL';
import loggerUTL from '../../utils/loggerUTL';
import checkUploadedImage from "./helpers/checkUploadedImage";

import COUNTRIES_FOR_TEMPLATE from "../../constants/countriesForTemplate";
import { CROSS_BORDER_VERIFICATION } from "../../constants/crossBorderDataSources";

// TODO CHANGE FROM STYLE MODULE TO NORMAL
const BiometricAuth = ({
  authRXS,
  countryRXS,
  biometricsRXS,
  loadingToggleAXN,
  biometricAuthenticationAXN,
  setAlertAXN,
  bioTriggerBooleansAXN,
  history,
}) => {
  const PREVIOUS_PAGE_ROUTE = COUNTRIES_FOR_TEMPLATE.includes(CROSS_BORDER_VERIFICATION)
    ? "/form-overview-template"
    : "/form-overview"

  const [isInit, setIsInit] = useState(true);
  const [cardImage, setCardImage] = useState('');
  const [cameraToggleST, setCameraToggleST] = useState(true);
  const [fileNamesST, setFileNamesST] = useState({
    fileNames: {
      file1: '',
    },
  });
  const [selfieST, setSelfieST] = useState({
    indexOfImage: null, // POSITIONAL
    identityDocFileIMG: {},
    selfieFileIMG: {},
    selfieURI: '',
  });

  useEffect(() => {
    // add document

    loadingToggleAXN(true);
    if (isInit) {
      loadingToggleAXN(false);
    }
    // eslint-disable-next-line
  }, [isInit]);

  useEffect(() => {
    // add document
    if (!isEmptyVAL(cardImage)) {
      handleSaveSelfieAndIdentityDoc(cardImage);
    }
    // eslint-disable-next-line
  }, [cardImage]);

  // HANDLE ON CAPTURE IMAGE
  const handleOnCapture = (blob) => setCardImage(blob);

  // HANDLE ON CAPTURE IMAGE
  const handleInitialize = (bool) => setIsInit(bool);

  // HANDLE ON CAPTURE IMAGE
  const handleSaveSelfieAndIdentityDoc = (dataURI) => {
    setSelfieST({
      ...selfieST,
      selfieFileIMG: dataURItoBlobUTL(dataURI, 'selfie'),
      selfieURI: dataURI,
    });
  };

  // HANDLE CAMERA TOGGLE
  const handleCameraToggle = () => setCameraToggleST(!cameraToggleST);

  // CLEAR IMAGE
  const handleClearImage = () => setCardImage(undefined);

  // HANDLE ON SUBMIT
  const handleSelfieSelection = (doc, index) => {
    setSelfieST({
      ...selfieST,
      indexOfImage: index,
      identityDocFileIMG: dataURItoBlobUTL(doc, 'identityDocument'),
    });
  };

  const fileToDataURI = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });
  }

  // HANDLE MANUAL FILE SELECTION
  const handleFileSelection = async (event) => {
    if (event.target.files.length > 0) {
      const targetName = event.target.name;
      const fileName = event.target.files[0].name || 'identityDocument';
      const file = event.target.files[0];
      const fileSize = file.size;
      let fileType = '';

      const originalDataURI = await fileToDataURI(file)

      const { alertMsg, dataURI } = await checkUploadedImage(
        originalDataURI,
        fileSize
      )

      if (dataURI) {
        handleSaveSelfieAndIdentityDoc(dataURI);
      }

      if (alertMsg.length > 0) {
        const alertMsgStr = alertMsg.join('\n')
        setAlertAXN(alertMsgStr, 'error')
      }

      if (targetName === 'file1') {
        fileType = 'file1';
      } else if (targetName === 'file2') {
        fileType = 'file2';
      } else if (targetName === 'file3') {
        fileType = 'file3';
      }

      setFileNamesST({
        ...fileNamesST,
        fileNames: {
          ...fileNamesST.fileNames,
          [fileType]: fileName,
        },
      });
    }
  };

  // HANDLE ON SUBMIT
  const handleOnSubmit = () => {
    loggerUTL('SUBMITTING...');
    // TODO: ADD FILE VALIDATION
    if (
      isEmptyVAL(selfieST.indexOfImage) ||
      isEmptyVAL(selfieST.identityDocFileIMG)
    ) {
      return setAlertAXN(
        transUTL('translateAlertMsg.compareIDtoSelfie'),
        'error'
      );
    }
    if (isEmptyVAL(selfieST.selfieFileIMG)) {
      loggerUTL('THIS IS IT...');
      return setAlertAXN(transUTL('translateAlertMsg.takeASelfie'), 'error');
    }

    // JSON CONSTRUCTION
    let formData = new FormData();
    const json = {
      service: ['Global Facial Recognition 2'],
      countryCode: '*',
      consentObtained: {
        'Global Facial Recognition 2': true,
      },
    };

    formData.append('json', JSON.stringify(json));
    formData.append(
      'selfieImage',
      selfieST.selfieFileIMG,
      selfieST.selfieFileIMG.name
    );
    formData.append(
      'documentImage',
      selfieST.identityDocFileIMG,
      selfieST.identityDocFileIMG.name
    );
    sessionStorage.setItem('selfieURI', JSON.stringify(selfieST.selfieURI));
    bioTriggerBooleansAXN({ ...biometricsRXS.bioTriggers, isBioAuth: true, isSelfieUploaded: false});
    biometricAuthenticationAXN(formData, history); 
  };

  return (
    <div className="common-form">
      <header className="header-primary">
        <h2>{transUTL('translateBiometrics.bioAuth')}</h2>
      </header>
      <div className="common-form__body ocr">
        {cameraToggleST === false && isInit ? (
          <p
            onClick={() => {
              handleCameraToggle();
            }}
            className="ocr__camera-toggle"
          >
            {transUTL('translateBiometrics.manualSelection')}
          </p>
        ) : null}

        {cameraToggleST && (
          <Fragment>
            <div className="ocr__form-btn">
              <p>{transUTL('translateBiometrics.identityCard')} 1</p>
              <div className="fileUpload ocr-btn">
                <span>
                  {!isEmptyVAL(fileNamesST.fileNames.file1)
                    ? `${fileNamesST.fileNames.file1} ${transUTL(
                      'translateBiometrics.uploaded'
                    )}`
                    : `${transUTL('translateBiometrics.noFiles')}`}
                </span>
                <input
                  type="file"
                  className="file-input"
                  name="file1"
                  onChange={handleFileSelection}
                />
              </div>
            </div>
          </Fragment>
        )}

        <div className="">
          {biometricsRXS.multiDocs.map((doc, index) => {
            if (cameraToggleST) {
              return (
                <div
                  key={index}
                  className="ocr__image-preview-item"
                  onClick={() => handleSelfieSelection(doc, index)}
                >
                  <img
                    src={doc}
                    alt="Document"
                    className={
                      selfieST.indexOfImage === index
                        ? 'ocr__selected-image'
                        : ''
                    }
                  />
                  {selfieST.indexOfImage === index && (
                    <span
                      className="material-icons white"
                      onClick={() => handleSelfieSelection(doc, index)}
                    >
                      check_circle
                    </span>
                  )}
                </div>
              );
            }

            return null;
          })}
        </div>

        {cameraToggleST === true && (
          <p
            onClick={() => {
              handleCameraToggle();
              handleInitialize(false);
            }}
            className="ocr__camera-toggle"
          >
            {transUTL('translateBiometrics.orTakePhoto')}
          </p>
        )}

        {cameraToggleST === false && (
          <Camera
            onCapture={handleOnCapture}
            onClear={handleClearImage}
            handleInitialize={handleInitialize}
          />
        )}

        {/* TODO: USE SOMETHING ELE INSTATED OF DATA URL - TAKES TOO LONG TO LOAD */}
        {/* SETUP A PRELOADING GIF WHILE CAMERA INITIALIZES */}
        {/* ADD ON CLICK PREVIEW FUNCTION */}

        {cameraToggleST === false && isInit && (
          <p className="ocr__selfie-instruction">
            {transUTL('translateBiometrics.selectOrClick')}
          </p>
        )}

        <div className="ocr__image-preview">
          {biometricsRXS.multiDocs.map((doc, index) => {
            if (!cameraToggleST && isInit) {
              return (
                <div
                  key={index}
                  className="ocr__image-preview-item"
                  onClick={() => handleSelfieSelection(doc, index)}
                >
                  <img
                    src={doc}
                    alt="Document"
                    className={
                      selfieST.indexOfImage === index
                        ? 'ocr__selected-image'
                        : ''
                    }
                  />
                  {selfieST.indexOfImage === index && (
                    <span
                      className="material-icons white"
                      onClick={() => handleSelfieSelection(doc, index)}
                    >
                      check_circle
                    </span>
                  )}
                </div>
              );
            }

            return null;
          })}
        </div>
      </div>

      {/* BUTTON */}
      <Button
        history={history}
        to={PREVIOUS_PAGE_ROUTE}
        handleOnSubmit={handleOnSubmit}
        btn1Text={transUTL('translateBtn.previousPage')}
        btn2Text={transUTL('translateBtn.nextPage')}
      />
    </div>
  );
};

BiometricAuth.propTypes = {
  authRXS: PropTypes.object.isRequired,
  biometricsRXS: PropTypes.object.isRequired,
  saveIdentityDocumentsAXN: PropTypes.func.isRequired,
  biometricAuthenticationAXN: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authRXS: state.authRXS,
  countryRXS: state.countryRXS,
  biometricsRXS: state.biometricsRXS,
});

export default connect(mapStateToProps, {
  saveIdentityDocumentsAXN,
  loadingToggleAXN,
  biometricAuthenticationAXN,
  setAlertAXN,
  bioTriggerBooleansAXN,
})(BiometricAuth);
